
export const generateErrorId = (): string => {
    const firstPart = Date.now().toString();
    const secondPart = Math.round(Math.random() * 1000);
    return `${firstPart}-${secondPart}`;
}

export const generateRandomId = (): string => {
    return crypto.randomUUID().slice(0, 8);
};

export const  uuidv4 = () => {
    return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
        const r = Math.random() * 16 | 0, v = c === 'x' ? r : (r & 0x3 | 0x8);
        return v.toString(16);
    });
};
